import { ref, watch } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-53d62cc2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "price-show-block-content"
};
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"title-content\" data-v-53d62cc2><div class=\"left\" data-v-53d62cc2><div class=\"title\" data-v-53d62cc2><span data-v-53d62cc2>国家/地区</span></div></div><div class=\"middle\" data-v-53d62cc2><div class=\"title\" data-v-53d62cc2><span data-v-53d62cc2>本地价格</span></div></div><div class=\"right\" data-v-53d62cc2><div class=\"title\" data-v-53d62cc2><span data-v-53d62cc2>折扣价</span></div></div></div>", 1);
const _hoisted_3 = {
  class: "price-content"
};
const _hoisted_4 = {
  class: "left"
};
const _hoisted_5 = {
  class: "middle"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "right"
}, [/*#__PURE__*/_createElementVNode("span", null, "免费")], -1));
export default /*#__PURE__*/_defineComponent({
  __name: 'PriceShowBlock',
  props: {
    priceList: null,
    selectedCountry: null
  },
  setup(__props) {
    const props = __props;
    const showPriceList = ref([]);
    const tempPriceList = ref([]);
    watch(() => props.selectedCountry, n => {
      if (n.length) {
        showPriceList.value = props.priceList.filter(item => n.includes(item.regionCode));
        tempPriceList.value = JSON.parse(JSON.stringify(showPriceList.value));
      } else {
        showPriceList.value = [];
        tempPriceList.value = [];
      }
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(showPriceList.value, item => {
        return _openBlock(), _createElementBlock("div", {
          class: "price-list",
          key: item.regionCode
        }, [_createElementVNode("div", _hoisted_4, [_createElementVNode("span", {
          class: _normalizeClass({
            underline: item.originProdPrice !== item.prodPrice
          })
        }, _toDisplayString(item.regionName), 3)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("span", null, _toDisplayString(item.prodPrice), 1)]), _hoisted_6]);
      }), 128))])]);
    };
  }
});